import type { CompanyMembershipSummaryDto } from '../tenancy/index.js';
import type { UserDto } from '../users/user.dto.js';
import type { UserStatus } from '../users/user.dto.js';

import type { ActiveCompanyContextDto } from './active-company-context.dto.js';

export const identityBootstrapNextActionValues = [
  'create-company',
  'select-company',
  'auto-select-company',
] as const;

export type IdentityBootstrapNextAction = (typeof identityBootstrapNextActionValues)[number];

export interface IdentityBootstrapResponse {
  mode: 'identity';
  user: UserDto;
  memberships: CompanyMembershipSummaryDto[];
  platformPermissions: string[];
  nextAction: IdentityBootstrapNextAction;
  autoSelectCompanyId?: string;
}

export interface CompanyBootstrapResponse {
  mode: 'company';
  user: UserDto;
  memberships: CompanyMembershipSummaryDto[];
  activeCompany: ActiveCompanyContextDto;
  id: string;
  email: string;
  status: UserStatus;
  platformPermissions?: string[];
  authzVersion: number;
}

export type BootstrapResponse = IdentityBootstrapResponse | CompanyBootstrapResponse;
